// import "./styles.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "./menuDropdown.css"
import "@popperjs/core";
import "bootstrap";

export default function MenuDropdown() {
  return (
    <div>
      <div className="dropdown">
        <a
          className="btn btn-secondary dropdown-toggle"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Menu
        </a>

        <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <li>
            <a className="dropdown-item" href="/about-us">
              About Us
            </a>
          </li>
          {/*
          <li>
            <a className="dropdown-item" href="/jobs-readiness">
              Job Readiness
            </a>
          </li>
          */}
          <li>
            <a className="dropdown-item" href="/resources">
              Resources
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="/success-stories">
              Success Stories
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="/contact-us">
              Contact Us
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="/check-eligibility">
              Check Eligibility
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}